import { Injectable } from '@angular/core';
import { EntityType } from '../../shared/enums/entity-type.enum';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { CalledConfig } from './models/called-config.model';
import { Called } from './models/called.model';
import { CalledStatus } from './enums/called-status.enum';

@Injectable()
export class CallAttendantService {
  constructor(private requestService: RequestService) {}

  async getList(
    entityId: number,
    entityType: EntityType,
    isOpen: boolean,
    page?: number,
    size?: number
  ): Promise<Called[]> {
    const params: any = {
      entityType: entityType,
      entityId: entityId,
      status: CalledStatus.IN_QUEUE,
      sort: 'asc',
    };
    if (!isOpen) {
      params.status = CalledStatus.CONFIRMED;
      params.page = page;
      params.size = size;
      params.sort = 'desc';
    }
    const urlRequest =
      APP_CONFIG.WEBSERVICE.ATTENDANT_QUEUE + '?' + this.requestService.buildUrlParams(params);
    let response = await this.requestService.getData(urlRequest);
    const list: Array<Called> = [];
    if (response && response.length > 0) {
      for (const q of response) {
        list.push(new Called(q));
      }
    }
    return list || [];
  }

  async answerCall(id: number): Promise<void> {
    const urlRequest = APP_CONFIG.WEBSERVICE.ATTENDANT_QUEUE;
    const data: any = {
      id: id,
      status: CalledStatus.CONFIRMED,
    };
    return await this.requestService.putData(urlRequest, data);
  }

  // CONFIG
  // ----------------

  async getConfig(storeId: number, entity: EntityType = EntityType.STORE): Promise<CalledConfig> {
    const urlRequest: string = `${APP_CONFIG.WEBSERVICE.ATTENDANT_QUEUE_CONFIG}?entityType=${entity}&entityId=${storeId}`;
    const response = await this.requestService.getData(urlRequest);
    if (response) {
      return new CalledConfig(response);
    }
    return response;
  }

  async saveConfig(config: CalledConfig): Promise<void> {
    if (config.id) {
      return await this.requestService.putData(
        APP_CONFIG.WEBSERVICE.ATTENDANT_QUEUE_CONFIG,
        config.toJson()
      );
    } else {
      return await this.requestService.postData(
        APP_CONFIG.WEBSERVICE.ATTENDANT_QUEUE_CONFIG,
        config.toJson()
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/call-attendant/call-attendant.service.ts